const wysiwygWrappers = document.querySelectorAll('.s-wysiwyg-wrapper');
const accordWrappers = document.querySelectorAll('.s-accord-wrapper')
const quoteWrappers = document.querySelectorAll('.s-quote-wrapper')
const tractionWrappers = document.querySelectorAll('.s-traction-wrapper')
const logosWrappers = document.querySelectorAll('.logos-wrapper')
const signpostingWrappers = document.querySelectorAll('.s-signposting-wrapper')
const buttonsWrappers = document.querySelectorAll('.s-buttons-wrapper')
const textVideoWrappers = document.querySelectorAll('.s-text-and-video-wrapper')

const sections = [wysiwygWrappers, accordWrappers, quoteWrappers, tractionWrappers, logosWrappers, signpostingWrappers, buttonsWrappers, textVideoWrappers];
const sectionsOnPage = []

function checkSibling(section) {
    // run throught the section array
    section.forEach(el => {

        // check if the section has a section after it
        if (el.nextElementSibling) {

            // if the next section has a white bg
            const classNames = ['s-accord-wrapper', 's-wysiwyg-wrapper', 's-quote-wrapper', 's-traction-wrapper', 'logos-wrapper', 's-signposting-wrapper', 's-buttons-wrapper', 's-text-and-video-wrapper']
            if (classNames.some(className => el.nextElementSibling.classList.contains(className))) {

                //remove the padding
                el.classList.add('g-remove-section-padding-bottom')
            }
        }
    });
}

//Check the section(s) is on the page
if (sections) {
  sections.forEach(section => {
      if (section.length > 0) {
          sectionsOnPage.push(section)
      }
  });

  // forEach section on page run the fn
  sectionsOnPage.forEach(section => {
    if (section) {
        checkSibling(section)
    }
  });
}
